import React, {Component} from 'react';
import axios from '../../axios-signup';
import AddOrRemove from '../../components/UI/AddOrRemove';
import {Redirect} from 'react-router-dom';
import Error from '../../components/UI/Error';
import wrapper from '../../hoc/wrapper';
import Header from "../../components/Header/Header";
import { Loader } from 'react-overlay-loader';

class AwsAccount extends Component {
    state = {
        emailAddress: this.props.location.state.emailAddress,
        awsAccountIds: [],
        awsOrgIds: [],
        submitted: false,
        links: {},
        errorMsg: '',
        unauthorized: false,
        inputAcct: '',
        entityType: 'awsAccount',
        loading: false,
        fromAws: this.props.location.state.fromAws || false
    };

    componentDidMount() {
        window.$(function () {
            window.jcf.replaceAll();
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        let accts = [...this.state.awsAccountIds];
        let orgs = [...this.state.awsOrgIds];
        if (this.state.inputAcct !== '') {
            if (this.state.entityType === 'awsAccount') {
                accts = accts.concat(this.state.inputAcct)
            } else {
                orgs = orgs.concat(this.state.inputAcct)
            }
        }
        axios.post("/aws-account", {
            emailAddress: this.state.emailAddress,
            awsAccountIds: accts,
            awsOrgIds: orgs,
        }).then(res => {
            this.setState({submitted: true, links: res.data.links, loading: false});
        }).catch(err => {
            if (err.response.status === 401) {
                this.setState({unauthorized: true, loading: false})
            } else {
                this.setState({errorMsg: err.response.data.error, loading: false});
            }
        })
    };

    handleChange = (event) => {
        this.setState({inputAcct: event.target.value});
    };

    handleEntityTypeChange = (envet) => {
        this.setState({entityType: event.target.value})
    }

    handleAdd = (event) => {
        event.preventDefault();
        if (this.state.inputAcct !== '') {
            if (this.state.entityType === 'awsAccount') {
                this.setState({awsAccountIds: this.state.awsAccountIds.concat(this.state.inputAcct), inputAcct: ''})
            } else {
                this.setState({awsOrgIds: this.state.awsOrgIds.concat(this.state.inputAcct), inputAcct: ''})
            }
        }
    };

    handleRemove = (idx) => (event) => {
        event.preventDefault();
        this.setState({awsAccountIds: this.state.awsAccountIds.filter((a, sidx) => idx !== sidx)});
    };

    handleRemoveOrg = (idx) => (event) => {
        event.preventDefault();
        this.setState({awsOrgIds: this.state.awsOrgIds.filter((o, sidx) => idx !== sidx)})
    }

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.setState({loading: true});
            let accts = [...this.state.awsAccountIds];
            let orgs = [...this.state.awsOrgIds];
            if (this.state.entityType === 'awsAccount') {
                accts = accts.concat(this.state.inputAcct)
            } else {
                orgs = orgs.concat(this.state.inputAcct)
            }

            axios.post("/aws-account", {
                emailAddress: this.state.emailAddress,
                awsAccountIds: accts,
                awsOrgIds: orgs,
            }).then(res => {
                this.setState({submitted: true, links: res.data.links, loading: false});
            }).catch(err => {
                if (err.response.status === 401) {
                    this.setState({unauthorized: true, loading: false})
                } else {
                    this.setState({errorMsg: err.response.data.error, loading: false});
                }
            })
        }
    };

    render() {
        let redirect = null;
        if (this.state.submitted) {
            redirect = <Redirect to={{
                pathname: '/signup/install-region',
                state: {emailAddress: this.state.emailAddress, fromAws: this.state.fromAws}
            }}/>
        } else if (this.state.unauthorized) {
            redirect = <Redirect to="/signup/"/>
        }

        const acctNum = this.state.awsAccountIds.length;
        const orgNum = this.state.awsOrgIds.length;
        return (
            <div>
                <Header currentWizard="6" fromAws={this.state.fromAws}/>
            <main role="main">
                <Loader fullPage={true} loading={this.state.loading}/>
                <section className="section yellow">
                    {redirect}
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10 col-center text-center">
                                <h1 className="black"><strong>AWS Configuration</strong></h1>
                                <h5 className="gray mb-4"><strong>Please enter your AWS Account ID or Organization ID below.<br/>
                                    If you have more than one account or organization, you can add additional entries using the plus
                                    sign.</strong></h5>
                                <Error errorMsg={this.state.errorMsg} divClass="col-lg-5 col-sm-6 col-center"/>
                                <div className="row">
                                    <div className="col-center">
                                        <div className="row no-gutters">
                                            <div className="col-6">
                                                <select name="entityType" onChange={this.handleEntityTypeChange} className="form-control">
                                                    <option value="awsAccount">AWS Account ID</option>
                                                    <option value="awsOrganization">AWS Organization ID</option>
                                                </select>
                                            </div>
                                            <div className="col-5">
                                                <input type="text"  id={"awsid"} value={this.state.inputAcct}
                                                       className="form-control" onChange={this.handleChange} onKeyPress={e => this.handleKeyPress(e)}/>
                                            </div>
                                            <AddOrRemove handleAdd={this.handleAdd}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-5 col-sm-6 col-center">
                                        {this.state.awsAccountIds.map((acct, idx) => (
                                            <div className="row no-gutters" key={idx}>
                                                <div className="col-11" style={{textAlign: 'left'}}>
                                                <p>Account: {acct}</p>
                                                </div>
                                                <AddOrRemove idx={idx} acctNum={acctNum}
                                                             handleRemove={this.handleRemove}/>
                                            </div>
                                        ))}
                                        {this.state.awsOrgIds.map((org, idx) => (
                                            <div className="row no-gutters" key={idx}>
                                                <div className="col-11" style={{textAlign: 'left'}}>
                                                    <p>Organization: {org}</p>
                                                </div>
                                                <AddOrRemove idx={idx} acctNum={orgNum}
                                                             handleRemove={this.handleRemoveOrg}/>
                                            </div>
                                        ))}
                                        <div className="form-group">
                                            <input type="submit" value="Submit" className="btn btn-primary"
                                                   onClick={this.handleSubmit}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            </div>
        )
    }
}

export default wrapper(AwsAccount);
